module.exports = __webpack_public_path__ + "img/Hungarian.bc3cd681.svg";